import src from '../assets/mettle-dark.png';
import { imageLogo } from './imageLogo';

export const MettleDarkLogo = imageLogo({
  src,
  width: 480,
  height: 353,
  alt: 'Mettle Golf',
});
